import { LISTS, SETTINGSSTATE } from '.'
import type { ListStateEvent } from '../../types'
import { workerResetLists } from '../actions/workerActions'
import { ListAction, SettingsType } from '../constants/enums'
import { LinkedList } from '../utilities/linkedlist'
import { pubSubList } from './pubSub'
import { registerTimer } from './state.timers'

export const initListChanges = () => {
    registerTimer(
        'listChanges',
        broadcastListChanges,
        SETTINGSSTATE[SettingsType.DEFAULT].modelListSortRate * 1000,
    )
}

function forceListChanges() {
    broadcastListChanges()
    registerTimer(
        'listChanges',
        broadcastListChanges,
        SETTINGSSTATE[SettingsType.DEFAULT].modelListSortRate * 1000,
    )
}

function broadcastListChanges() {
    const updated = {}
    Object.entries(LISTS).forEach(([key, list]) => {
        if (list.changed) {
            pubSubList.emit(key, list)
            updated[key] = list
        }
        list.changed = false
    })

    pubSubList.emit('UPDATE_COMPLETE', updated)
}

export function deleteLists(data: ListStateEvent['data']) {
    const { lists } = data
    lists.forEach((list) => {
        const { key } = list
        if (!key) return
        delete LISTS[key]
    })
}

export function resetLists(data: ListStateEvent['data']) {
    const { lists } = data

    lists.forEach((list) => {
        const { values, key } = list
        LISTS[key] = new LinkedList(values, key, workerResetLists)
        pubSubList.emit(key, LISTS[key])
    })
}

export function modifyLists(data: ListStateEvent['data']) {
    const { lists, forceUIUpdate } = data
    lists.forEach((data) => {
        const { action, item, list, reference } = data

        switch (action) {
            case ListAction.INSERT:
                // console.log(`About to insert ${item} after ${reference} in ${list}.`)
                LISTS[list].insertBefore(item, reference)
                break
            case ListAction.REMOVE:
                // console.log(`About to remove ${item} from ${list}.`)
                LISTS[list].remove(item)
                break
        }
    })
    if (forceUIUpdate) {
        forceListChanges()
    }
}
